import { getSessionToken } from '@/lib/auth'
import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'

const AccountRoute = lazyRouteComponent(
  () => import('@/features/account/Account'),
  'Account'
)

export const Route = createFileRoute('/conta')({
  beforeLoad: () => {
    const token = getSessionToken()
    const urlParams = new URLSearchParams(window.location.search)
    const magicLinkToken = urlParams.get('token')
    if (!token && !magicLinkToken) {
      throw redirect({ to: '/entrar' })
    }
  },
  component: AccountRoute,
})
